import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

export const StyledAutoWDConfirmationModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  text-align: center;
  height: 85vh;
  max-width: 500px;
  margin: auto;
  h2 {
    font-size: ${themeStyles.fonts.text.h2.size.mobile};
    line-height: 26px;
  }
  ${themeMedia.tablet`
      height: 100%;
      justify-content: center; 
      h2 {
        line-height: initial;
      }   
    `}
`
export const StyledAutoWDConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  gap: 2.5rem;
  ${themeMedia.tablet`
    margin: 1rem 0 2rem 0;
    gap: 2rem;
  `}
`

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`
